import useSubmit from "./useSubmit";
import { FormikHelpers } from "formik";
import { AxiosRequestConfig } from "axios";
import { supplierProductLinkPatchRequest } from "src/utils/submit/submitProduct";
import { useState } from "react";
import useUpdateEffect from "../useUpdateEffect";


export const useProductSubmit = (
  currentSubmitFunction: (
    v: any
  ) => AxiosRequestConfig<any> | AxiosRequestConfig<any>[]
): [
  any,
  (
    values: any,
    changedSupplierProducts: any,
    formikHelpers: FormikHelpers<any>
  ) => any,
  boolean
] => {
  const [resultMain, submitMain] = useSubmit<any>(currentSubmitFunction);
  const [supplierProductSave, submitSupplierProducts] = useSubmit(supplierProductLinkPatchRequest, {logLevel: ["error","success"]});

  const result = {
    main: resultMain,
    supplierProduct: supplierProductSave,
  };

  const [submitting, setSubmitting] = useState(false);
      useUpdateEffect(() => { setSubmitting(false); }, [resultMain])

  const submitProduct = (
    values: any,
    changedSupplierProducts: any,
    formikHelpers: FormikHelpers<any>
  ) => {
    setSubmitting(true);
    submitSupplierProducts({values, changedSupplierProducts}, formikHelpers);

    submitMain(values, formikHelpers); 
  };

  return [resultMain, submitProduct, submitting];
};

